"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _theme = require("@vds/theme");

var _icons = require("@vds/icons");

var _inputs = require("@vds-core/inputs");

var _typography = require("@vds/typography");

var _tooltips = require("@vds/tooltips");

var TextArea = function TextArea(props) {
  return /*#__PURE__*/_react["default"].createElement(_inputs.TextArea, (0, _extends2["default"])({}, props, {
    iconConfig: _icons.IconData,
    typescale: _typography.TypographyConfig.getTypescale(),
    color: _theme.colors,
    bodyConfig: _typography.BodyConfig,
    Tooltip: _tooltips.Tooltip,
    Body: _typography.Body,
    Micro: _typography.Micro
  }));
};

var _default = TextArea;
exports["default"] = _default;